import { fetchApi } from '@/config/axiosSetting';
import {
  GetOfflineFileCheckQueryParamsType,
  GetOfflineFileCheckQueryResponseType,
} from '@/modules/OfflineFiles/queries/getOfflineFileCheck/getOfflineFileCheckQuery.type';

export const getOfflineFileCheckFunction = (
  params: GetOfflineFileCheckQueryParamsType,
): Promise<GetOfflineFileCheckQueryResponseType> => {
  return fetchApi.get(`offline_shooting/${params.id}/check-file/`, { params });
};
